export default __webpack_public_path__ + "static/media/bm.1bf880b5.svg";